module.exports = __webpack_public_path__ + "static/media/zolaicons.3322cf51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/zolaicons.svg?24613844
// module id = 1672
// module chunks = 49